// extracted by mini-css-extract-plugin
export default {"wrap":"HomeView_wrap__xuMSk","name":"HomeView_name__1szMZ","wrapMast":"HomeView_wrapMast__U5fY1","toTopBtn":"HomeView_toTopBtn__J1iLH"};